export enum ListingCategory {
    LIVE = "live",
    UPCOMING = "upcoming",
    HISTORICAL = "historical"
}